// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"419c7e71","455":"87053f62","977":"2e28a1c8"}[chunkId] + ".chunk.js";
};